import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/**
 * @file useUpdate 强制更新组件
 */
import { useCallback, useState } from 'react';
export function useUpdate() {
  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      setState = _useState2[1];

  return useCallback(function () {
    setState(function (num) {
      return num + 1;
    });
  }, []);
}